import {Component, HostBinding, HostListener, OnDestroy, OnInit} from '@angular/core';
import * as fromStore from '../store';
import {Store} from "@ngrx/store";
import {Observable, Subscription} from "rxjs";
import {IActivity} from "../activities/activity";
import {Config} from "../config/config";
import {Website} from "../websites/website/website";
import {filter, first, switchMap} from "rxjs/operators";
import {User} from "../user/user";

@Component({
    selector: 'db-activity-notifications',
    templateUrl: './activity-notifications.component.html',
    styleUrls: ['./activity-notifications.component.scss'],
    standalone: false
})
export class ActivityNotificationsComponent implements OnInit, OnDestroy {

  public loading: boolean;
  public activityNotificatonsArray: any;

  public toggled$: Observable<boolean>;
  private _toggled: boolean;
  private _toggledSubscription: Subscription;
  public activityNotificatons$: Observable<IActivity[]>;
  public activityNotificatonsLoading$: Observable<boolean>;
  public websitesArray: Array<number> = [];
  public websites$: Observable<Website[]>;
  public hasHostingBanner: any;
  public user: User;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
  ) {
  }

  @HostBinding('class.db-activity-notifications__host_toggled') get hostToggled(): boolean {
    return this._toggled;
  }

  @HostListener('click') onMouseOver() {
    this.toggle();
  }

  ngOnInit(): void {
    this.toggled$ = this._store.select(fromStore.getActivityNotificationsToggled);

    this.websites$ = <any>this._store.select(fromStore.getWebsites);
    this.websites$.subscribe((websites: Website[]) => {
      if (websites.length) {
        websites.forEach((item) => {
          this.websitesArray.push(item.id);
        });
      }
    });

    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUser)),
        first()
      )
      .subscribe((user: User) => {
        this.user = user;
        this.hasHostingBanner = this.user ? localStorage.getItem("showConnectBanner" + this.user.id) : false;
      });

    this.activityNotificatons$ = this._store.select(fromStore.getActivities);
    this.activityNotificatons$.subscribe((data) => {
      this.activityNotificatonsArray = data.filter((activity: IActivity) => !Config.ignoredActivities.includes(activity.action) && activity.status === 'failed' && this.websitesArray && this.websitesArray.includes(activity.websiteId))
        .sort((n1: IActivity, n2: IActivity): number => n2.date.getTime() - n1.date.getTime());
    });
    this.activityNotificatonsLoading$ = this._store.select(fromStore.getActivitiesLoading);

    this._toggledSubscription = this.toggled$.subscribe((toggled: boolean): void => {
      this._toggled = toggled;

      if (this._toggled) {
        this._store.dispatch(new fromStore.MarkReadActivityNotifications());
      }
    });
  }

  ngOnDestroy(): void {
    this._toggledSubscription.unsubscribe();
  }

  public toggle(): void {
    this._store.dispatch(new fromStore.ToggleActivityNotifications());
  }

  public stopEvent($event: any): void {
    $event.stopPropagation();
  }

}
